import type { StackProps } from '@mui/material/Stack';

import Stack from '@mui/material/Stack';

import QRButton from './sidebar-bottom/qr-button';
import ReportBug from './sidebar-bottom/report-bug';
// ----------------------------------------------------------------------

export function NavUpgrade({ sx, ...other }: StackProps) {
  return (
    <Stack sx={{ px: 2, pb: 2, textAlign: 'center', ...sx }} {...other}>
      <Stack alignItems="center" gap={1}>
        <QRButton />
        <ReportBug />
      </Stack>
    </Stack>
  );
}
